module.exports = __webpack_public_path__ + "img/active_product4.51f9870.png";